export default class StickyHeader extends HTMLElement {
  constructor() {
    super()
    this.isOpenMobileMenu = false
    this.animationTimeOut = 300
    this.lastScrollTop = 0;

  }

  connectedCallback() {
    this.header = document.querySelector(".section-header-sticky")
    this.htmlElement = document.querySelector("html")
    if (!this.header) {
      return null
    }

    this.setHeaderHeight();
    this.defineElements()
    this.addListeners()
  }

  defineElements() {
    this.mobileOpenButton = this.header.querySelector(".header__menu-open-button") || null
    this.navigationItems = this.header.querySelectorAll(".header__menu-list-item:has(.header__menu-item--has-mega-menu)") || null
    this.navigationItemsSimple = this.header.querySelectorAll(".header__menu-list-item:not(:has(.header__menu-item--has-mega-menu))") || null
    this.navigationWrap = this.header.querySelector(".header__navigation") || null
  }


  addListeners() {
    window.addEventListener("scroll",  () => {
      const currentScroll = window.scrollY;

      if (currentScroll <= 200 ){
        this.classList.add("is-transparent")
      }else{
        this.classList.remove("is-transparent")
      }

      if (currentScroll > this.lastScrollTop) {
        this.classList.add("is-hidden")
        //console.log("Scrolling down");
      } else if (currentScroll < this.lastScrollTop) {
        this.classList.remove("is-hidden")
        //console.log("Scrolling up");
      }

      this.lastScrollTop = currentScroll <= 0 ? 0 : currentScroll; // For Mobile or negative scrolling
    });

    this.mobileOpenButton && this.mobileOpenButton.addEventListener('click', this.clickMobileMenuOpenButton.bind(this))
   
    this.navigationItems.forEach(item => {
      item.addEventListener('mouseenter', () => {
        document.querySelector(".navigation-activ")?.classList.remove('navigation-activ') 
        this.header.classList.add('hovered-navigation');
        item.classList.add('navigation-activ')
        this.navigationWrap.classList.add('submenu-activ')
      });
    });
    
    this.navigationItemsSimple.forEach(item => {
      item.addEventListener('mouseenter', () => {
        document.querySelector(".navigation-activ")?.classList.remove('navigation-activ');
        item.classList.add('navigation-activ');
        this.header.classList.remove("hovered-navigation");
      });
    });

    this.navigationWrap.addEventListener('mouseleave', () => {
      document.querySelector(".navigation-activ")?.classList.remove('navigation-activ');
      this.header.classList.remove('hovered-navigation');
    });
  }

  clickMobileMenuOpenButton() {
    this.isOpenMobileMenu ? this.closeMobileMenu() : this.openMobileMenu();
    this.setButtonIcon();
  }

  setButtonIcon() {
    this.mobileOpenButton.classList.toggle('open-menu-icon', !this.isOpenMobileMenu)
    this.mobileOpenButton.classList.toggle('close-menu-icon', this.isOpenMobileMenu)
  }

  setHeaderHeight() {
    document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
  }

  toggleMobileMenu(show) {
    show = (show !== undefined) ? show : !this.isOpenMobileMenu
    this.isOpenMobileMenu = show
    this.isOpenMobileMenu ? this.header.setAttribute("open", "") : this.header.removeAttribute("open")
  }

  openMobileMenu() {
    this.toggleMobileMenu(true)
    this.htmlElement.classList.add('overflow-hidden');
  }

  closeMobileMenu() {
    this.toggleMobileMenu(false)
    this.htmlElement.classList.remove('overflow-hidden');
  }

}

customElements.define("sticky-header", StickyHeader)
